import { compose } from '@fluentui/react-bindings';
import { commonPropTypes } from '../../utils';
import { Box } from '../Box/Box';
export var datepickerCalendarHeaderCellClassName = 'ui-datepicker__calendarheadercell';
/**
 * A DatepickerCalendarHeaderCell is used to display header cells in DatepickerCalendar grid.
 */

export var DatepickerCalendarHeaderCell = /*#__PURE__*/function () {
  var DatepickerCalendarHeaderCell = compose(Box, {
    className: datepickerCalendarHeaderCellClassName,
    displayName: 'DatepickerCalendarHeaderCell',
    overrideStyles: true,
    shorthandConfig: {
      mappedProp: 'content'
    }
  });
  DatepickerCalendarHeaderCell.defaultProps = {
    as: 'th'
  };
  DatepickerCalendarHeaderCell.propTypes = commonPropTypes.createCommon();
  return DatepickerCalendarHeaderCell;
}();
//# sourceMappingURL=DatepickerCalendarHeaderCell.js.map
